// init Branch
var branch = window.branch;
// var options = { no_journeys: true };
branch.init(process.env.VUE_APP_BRANCH_IO_KEY);